// Sayfalama durumunu localStorage'da tutmak için yardımcı fonksiyonlar

/**
 * Sayfalama durumunu lokal depolama alanına kaydet
 * @param {string} screenKey - Ekran tanımlayıcısı
 * @param {number} currentPage - Mevcut sayfa numarası
 * @param {number} itemsPerPage - Sayfa başına öğe sayısı
 */
export const savePaginationState = (screenKey, currentPage, itemsPerPage) => {
  try {
    const paginationState = {
      currentPage,
      itemsPerPage,
      lastUpdated: new Date().getTime()
    };
    localStorage.setItem(`pagination_${screenKey}`, JSON.stringify(paginationState));
  } catch (error) {
    console.error('Pagination durumu kaydedilemedi:', error);
  }
};

/**
 * Sayfalama durumunu lokal depolama alanından getir
 * @param {string} screenKey - Ekran tanımlayıcısı
 * @param {number} defaultPage - Varsayılan sayfa numarası
 * @param {number} defaultItemsPerPage - Varsayılan sayfa başına öğe sayısı
 * @returns {Object} - Kayıtlı sayfalama durumu veya varsayılan değerler
 */
export const loadPaginationState = (screenKey, defaultPage = 1, defaultItemsPerPage = 5) => {
  try {
    const savedState = localStorage.getItem(`pagination_${screenKey}`);
    if (savedState) {
      return JSON.parse(savedState);
    }
  } catch (error) {
    console.error('Pagination durumu yüklenemedi:', error);
  }
  
  return {
    currentPage: defaultPage,
    itemsPerPage: defaultItemsPerPage
  };
};
